module.exports = __webpack_public_path__ + "img/project-banner.64c0ae97.png";